export default "__VITE_ASSET__32af4676__"